import { render } from "./PhoneVerificationComponent.vue?vue&type=template&id=61466b2e"
import script from "./PhoneVerificationComponent.ts?vue&type=script&lang=js"
export * from "./PhoneVerificationComponent.ts?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src111513322/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__